const userStore = {
  state: {
    // 数据
    userInfo: JSON.parse(sessionStorage.getItem('userInfo')) || {},
    Mcode: '111123',
    msg: '你好vue3',
  },
  getters: {
    // 计算属性
    // 访问getter的方法有：1）store.getters.Mcode  2）this.$store.getters.Mcode
    // 3）通过mapGetters辅助函数
    // import { mapGetters } from 'vuex
    // 使用对象展开运算符将 getter 混入 computed 对象中
    // ...mapGetters([
    //   'Mcode',
    //   'user'
    // ])
    reverseMsg(state) {
      return state.msg.split('').reverse().join('');
    },
  },
  mutations: {
    changeUserInfo(state, userInfo) {
      state.userInfo = userInfo;
      sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
    },
    changeMcode(state, Mcode) {
      state.Mcode = Mcode;
    },
    changeMsg(state, Msg) {
      state.msg = Msg;
    },
  },
  actions: {
    // 执行一些 异步操作 主要用于执行 mutations里面的方法
    changeMcode(codes, relcode) {
      codes.commit('changeMcode', relcode); // 执行mutations里面的changeMcode方法
    },
  },
};
export default userStore;
